import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';
import { Medal, Palette, Users, Star } from 'lucide-react';

const ICONS = { medal: Medal, palette: Palette, users: Users, star: Star };

export default function Rewards() {
  const [d, setD] = useState(null);
  useEffect(() => { (async () => { const { data } = await api.get('/founders/rewards'); setD(data); })(); }, []);
  if (!d) return <div style={{ color: 'var(--heritage-plum)' }}>Loading…</div>;
  return (
    <div className="space-y-6">
      <Panel className="p-8">
        <div className="h-eyebrow">Founder Rewards</div>
        <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>Milestones & referrals</div>
      </Panel>

      <div className="grid md:grid-cols-2 gap-6">
        <Panel className="p-6">
          <div className="h-eyebrow mb-3">Your referral code</div>
          <div className="h-serif text-3xl" style={{ color: 'var(--heritage-plum)' }}>{d.referral_code}</div>
          <div className="text-sm mt-1 opacity-80" style={{ color: 'var(--heritage-plum)' }}>Share this code with future founders to unlock rewards.</div>
          <div className="mt-4 h-eyebrow">Referrals</div>
          <div className="h-serif text-2xl" style={{ color: 'var(--heritage-plum)' }}>{d.referrals}</div>
        </Panel>

        <Panel className="p-6">
          <div className="h-eyebrow mb-3">Milestones</div>
          <ul className="space-y-3">
            {d.milestones.map((m) => {
              const Icon = ICONS[m.icon] || Medal;
              return (
                <li key={m.label} className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center`}
                       style={{ background: m.unlocked ? 'var(--heritage-plum)' : 'transparent', color: m.unlocked ? 'var(--heritage-cream)' : 'var(--heritage-plum)', border: '2px solid var(--heritage-plum)' }}>
                    <Icon size={16} />
                  </div>
                  <div>
                    <div className="h-serif text-lg" style={{ color: 'var(--heritage-plum)' }}>{m.label}</div>
                    <div className="h-eyebrow">{m.unlocked ? 'Unlocked' : 'Locked'}</div>
                  </div>
                </li>
              );
            })}
          </ul>
        </Panel>
      </div>
    </div>
  );
}
